import React from "react";
import { useSelector } from "react-redux";
import MessageDisplay from "./Panes/MessageDisplay";

export default function SmsLandingPage() {
    const { messageData } = useSelector((state) => state);
    return (
        <MessageDisplay
            subject={messageData.subject}
            body={messageData.body}
            logo={messageData.logo}
            className="inform-sms"
            extraLinks={[<a href={messageData.resubLink}>Re-Subscribe</a>]}
        />
    );
}
